export * from './miniapp-mindbody';
